export const habaMyAccountNavigation = {
  myAccountNavigation: {
    benefits: {
      label: 'Vorteile',
      presentDesk: 'Geschenketisch'
    },
    customerData: {
      changeData: 'Kundendaten ändern',
      label: 'Kundendaten'
    },
    general: {
      article: 'Meine Artikel',
      history: 'Meine Bestellungen',
      overview: 'Meine Übersicht',
      premium: 'Premiumversand',
      return: 'Rücksendung',
      wishlist: 'Meine Merkliste'
    },
    navigation: {
      heading: 'Overview',
      clientData: 'My client data',
      personalData: 'Personal data',
      companyData: 'Client',
      loginData: 'Login data',
      billingAddress: 'Billing address',
      deliveryAddress: 'My delivery addresses',
      orderHistory : 'My order overview'
    }
  }
};
